import { displayAccessCodeResult } from 'actions/accessCodes';

export default function handleAccessCodeResult({ AccessCodeResult: result }) {
  return (dispatch) => {
    if (result) {
      dispatch(displayAccessCodeResult(result));
    }
  };
}